<script setup lang="ts">
import CreditReportFaq from "@/components/Quiz/CreditReportFaq.vue";


const props = defineProps<{ email: string }>()

const phrases = [
  'You have signed a contract with Johnson Law Group, a law firm regulated by the SRA, to handle your claim(s)',
  `We'll let you know what agreements we find, you will receive a confirmation email at ${props.email} confirming your details`,
  'JLG will handle all legal procedures and keep you updated through the bespoke JLG Client Portal'
]

</script>

<template>
  <img src="@/assets/images/still-searching.webp"
       alt="still-searching"
       class="w-2/3 mx-auto py-2 mb-4"/>


  <p class="text-center text-xl mb-4 font-medium">
    Your vehicle(s) do not qualify for any claims at the moment.
  </p>

  <p class="text-gray-600 mb-4 font-medium  text-center text-lg">
    However, we are still searching!
  </p>


  <CreditReportFaq :phrases="phrases" class="mt-6"/>
</template>
